import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import { useFormCreateAgencys } from '../../controllers/Agencys/CreateAgencysController';
import LoadingScreen from '../../components/LoadingScreen';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

const AgencyForm: React.FC = () => {
    const { getAgencyFormController } = useFormCreateAgencys();
    const history = useHistory();

    if (getAgencyFormController.loading) {
        return (
            <LoadingScreen />
        );
    };

    return (
        <div style={{ height: '100%' }} className="card p-align-center p-justify-center">
            <h5>Cadastro de órgão</h5>
            <div className="p-grid p-fluid">
                <div className="p-field p-col-12 p-md-8">
                    <label htmlFor="ctfReg" >Nome</label>
                    <InputText id="ctfReg"
                        {...getAgencyFormController.formik.getFieldProps('NOME_ORGAO')}
                        onChange={getAgencyFormController.formik.handleChange('NOME_ORGAO')}
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getAgencyFormController.formik.touched.NOME_ORGAO && getAgencyFormController.formik.errors.NOME_ORGAO,
                        'popup-form-inactive': !(getAgencyFormController.formik.touched.NOME_ORGAO && getAgencyFormController.formik.errors.NOME_ORGAO),
                    })}
                    >{getAgencyFormController.formik.errors.NOME_ORGAO}</div>
                </div>

                <div className="p-field p-col-12 p-md-4">
                    <label htmlFor="numMotor">CNPJ</label>
                    <InputText id="numMotor"
                        {...getAgencyFormController.formik.getFieldProps('CNPJ_ORGAO')}
                        onChange={getAgencyFormController.formik.handleChange('CNPJ_ORGAO')}
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getAgencyFormController.formik.touched.CNPJ_ORGAO && getAgencyFormController.formik.errors.CNPJ_ORGAO,
                        'popup-form-inactive': !(getAgencyFormController.formik.touched.CNPJ_ORGAO && getAgencyFormController.formik.errors.CNPJ_ORGAO),
                    })}
                    >{getAgencyFormController.formik.errors.CNPJ_ORGAO}</div>
                </div>

                <div className="p-field p-col-12 p-md-9">
                    <label htmlFor="numMotor">Cidade</label>
                    <InputText id="numMotor"
                        {...getAgencyFormController.formik.getFieldProps('CIDADE_ORGAO')}
                        onChange={getAgencyFormController.formik.handleChange('CIDADE_ORGAO')}
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getAgencyFormController.formik.touched.CIDADE_ORGAO && getAgencyFormController.formik.errors.CIDADE_ORGAO,
                        'popup-form-inactive': !(getAgencyFormController.formik.touched.CIDADE_ORGAO && getAgencyFormController.formik.errors.CIDADE_ORGAO),
                    })}
                    >{getAgencyFormController.formik.errors.CIDADE_ORGAO}</div>
                </div>

                <div className="p-field p-col-12 p-md-3">
                    <label htmlFor="anoLicens">Bairro</label>
                    <InputText id="anoLicens"
                        {...getAgencyFormController.formik.getFieldProps('BAIRRO_ORGAO')}
                        onChange={getAgencyFormController.formik.handleChange('BAIRRO_ORGAO')}
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getAgencyFormController.formik.touched.BAIRRO_ORGAO && getAgencyFormController.formik.errors.BAIRRO_ORGAO,
                        'popup-form-inactive': !(getAgencyFormController.formik.touched.BAIRRO_ORGAO && getAgencyFormController.formik.errors.BAIRRO_ORGAO),
                    })}
                    >{getAgencyFormController.formik.errors.BAIRRO_ORGAO}</div>
                </div>

                <div className="p-field p-col-12 p-md-9">
                    <label htmlFor="anoLicens">Endereço</label>
                    <InputText id="anoLicens"
                        {...getAgencyFormController.formik.getFieldProps('ENDERECO_ORGAO')}
                        onChange={getAgencyFormController.formik.handleChange('ENDERECO_ORGAO')}
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getAgencyFormController.formik.touched.ENDERECO_ORGAO && getAgencyFormController.formik.errors.ENDERECO_ORGAO,
                        'popup-form-inactive': !(getAgencyFormController.formik.touched.ENDERECO_ORGAO && getAgencyFormController.formik.errors.ENDERECO_ORGAO),
                    })}
                    >{getAgencyFormController.formik.errors.ENDERECO_ORGAO}</div>
                </div>

                <div className="p-field p-col-12 p-md-3">
                    <label htmlFor="ctfReg">CEP</label>
                    <InputText id="ctfReg"
                        {...getAgencyFormController.formik.getFieldProps('CEP_ORGAO')}
                        onChange={getAgencyFormController.formik.handleChange('CEP_ORGAO')}
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getAgencyFormController.formik.touched.CEP_ORGAO && getAgencyFormController.formik.errors.CEP_ORGAO,
                        'popup-form-inactive': !(getAgencyFormController.formik.touched.CEP_ORGAO && getAgencyFormController.formik.errors.CEP_ORGAO),
                    })}
                    >{getAgencyFormController.formik.errors.CEP_ORGAO}</div>
                </div>
            </div>

            <div className="p-fluid p-grid p-justify-between">
                <div className="p-col-12 p-md-4" >
                    <Button
                        type="submit"
                        label="Cadastrar"
                        onClick={() => getAgencyFormController.formik.handleSubmit()}
                    />
                </div>

                <div className="p-col-12 p-md-4">
                    <Button
                        type="button"
                        className="p-button-secondary"
                        label="Cancelar"
                        onClick={() => history.goBack()}
                    />
                </div>
            </div>
        </div>
    );
};

export default AgencyForm;